function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#F2C94C",
  fillRule: "evenodd",
  d: "M15.117 14.117C.27 28.964.27 53.036 15.117 67.883c14.847 14.847 38.918 14.847 53.765 0 14.847-14.847 14.847-38.919 0-53.766C54.035-.73 29.964-.73 15.117 14.117zm-2.122 55.887c-16.018-16.018-16.018-41.99 0-58.008 16.019-16.019 41.99-16.019 58.009 0 16.018 16.018 16.018 41.99 0 58.008-16.019 16.019-41.99 16.019-58.009 0zm30.998-48.27v29.64h-3v-29.64h3zm0 37.543v-3.952h-3v3.952h3z",
  clipRule: "evenodd"
});

function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 83,
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "eafb916889312bfe0918b066d86cb429.svg";
export { SvgAlert as ReactComponent };